var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceForecasting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.788 31.0175C19.2871 31.0175 18.7892 30.8076 18.4383 30.3975L7.92855 18.1504C7.4763 17.6228 7.37257 16.8807 7.66242 16.2495C7.95286 15.6188 8.58352 15.214 9.27821 15.214H15.25C17.9126 15.214 20.0784 13.0481 20.0784 10.3856C20.0784 7.72299 17.9126 5.55714 15.25 5.55714H9.27821C8.29605 5.55714 7.50001 4.7611 7.50001 3.77894C7.50001 2.79677 8.29605 2.00073 9.27821 2.00073H15.25C19.8739 2.00073 23.6348 5.76222 23.6348 10.3856C23.6348 15.0089 19.8733 18.7704 15.2494 18.7704H13.147L21.1365 28.081C21.776 28.8267 21.6907 29.9488 20.9456 30.5883C20.6101 30.8764 20.1982 31.0175 19.788 31.0175Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7272 5.55641H9.2782C8.29604 5.55641 7.5 4.76036 7.5 3.7782C7.5 2.79604 8.29604 2 9.2782 2H25.7272C26.7093 2 27.5054 2.79604 27.5054 3.7782C27.5054 4.76036 26.7093 5.55641 25.7272 5.55641Z",
    fill: "#F1935C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7272 12.1631H9.2782C8.29604 12.1631 7.5 11.3671 7.5 10.3849C7.5 9.40273 8.29604 8.60669 9.2782 8.60669H25.7272C26.7093 8.60669 27.5054 9.40273 27.5054 10.3849C27.5054 11.3671 26.7093 12.1631 25.7272 12.1631Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceForecasting);
export default __webpack_public_path__ + "static/media/priceForecasting.50c30023632f5c5db33d58c3533eed24.svg";
export { ForwardRef as ReactComponent };